export * from "./Agent";
export * from "./AgentSummary";
export * from "./AutoComplete";
export * from "./AutocompleteKeyword";
export * from "./BackgroundJob";
export * from "./BulkTest";
export * from "./Deployment";
export * from "./DialogData";
export * from "./Entity";
export * from "./EntityValue";
export * from "./Intent";
export * from "./IntentPredictResult";
export * from "./IntentSentence";
export * from "./Locale";
export * from "./Member";
export * from "./Page";
export * from "./Selector";
export * from "./Skill";
export * from "./Statistics";
export * from "./Synonym";
export * from "./Typo";
export * from "./User";
export * from "./WebSocket";


export type DictType<T = any> = {[key: string]: T};

export interface ApiResponse<T> {
    data?: T;
    msg?: string;
}

export type LabelKeyValueItem<T = any> = { labelKey: string; value: T };
export const getLabelKeyFromValue = <T>(items: LabelKeyValueItem<T>[], value: T) => {
    return items.find(item => item.value === value)?.labelKey ?? "";
};
